module.exports = __webpack_public_path__ + "img/a.7f4310f2.jpg";